import React from 'react'

import { useResortMenuStore } from '../../store/resortMenuStore'

type ChooseDestinationProps = {
    children : JSX.Element | JSX.Element[]
}

const ChooseDestination = (props: ChooseDestinationProps) => {

    // Zustand store
    const toggleMenuOpen = useResortMenuStore( state => state.toggleMenuOpen )
    const isMenuOpen = useResortMenuStore( state => state.isMenuOpen )

    const handleMenuClick = () => {
        toggleMenuOpen()
    }

  return (
    <div className='destMainMenuDiv'>
        <div className='chooseDestContainer' onClick={handleMenuClick}>Choose a <span className='white'>Destination</span> <span className='caret white'></span></div>
        {
            isMenuOpen && <div className='destOptions'>{props.children}</div>
        }
        
    </div>
  )
}

export default ChooseDestination